module.exports = __webpack_public_path__ + "static/media/mn10.c879af40.jpeg";